<template>
    <!-- 老人列表 -->
    <div>
      <el-row>
          <!-- 所有老人,入院出院的老人 -->
          <el-form
            :inline="true"
            :model="formInline"
            class="demo-form-inline toolbar"
            style="padding-bottom: 0px;padding-top: 10px"
            @submit.native.prevent
          >
            <el-form-item label="老人姓名" label-width="90px">
              <el-input
                clearable
                style="width: 140px"
                v-model.trim="formInline.oldName"
                placeholder="请输入老人姓名"
                @keyup.enter.native.prevent="enterSearchMember"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-select v-model="formInline.sex" style="width: 120px" clearable>
                <el-option value="0" label="男"></el-option>
                <el-option value="1" label="女"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="在院状态">
              <el-select v-model="formInline.serviceType" style="width: 120px" clearable>
                <el-option value="0" label="离院"></el-option>
                <el-option value="1" label="在院"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="老人类别">
              <el-select v-model="formInline.interest" style="width: 120px" clearable>
                <el-option label="普通" value="普通"></el-option>
                <el-option label="高龄" value="高龄"></el-option>
                <el-option label="独居" value="独居"></el-option>
                <el-option label="残疾" value="残疾"></el-option>
                <el-option label="空巢" value="空巢"></el-option>
                <el-option label="特困对象" value="特困对象"></el-option>
                <el-option label="低保对象" value="低保对象"></el-option>
                <el-option label="半失能对象" value="半失能对象"></el-option>
                <el-option label="失能对象" value="失能对象"></el-option>
                <el-option label="其他类别" value="其他类别"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="自理等级">
              <el-select v-model="formInline.levelCareName" style="width: 120px" clearable>
                <el-option value="自理" label="自理"></el-option>
                <el-option value="半自理" label="半自理"></el-option>
                <el-option value="失能" label="失能"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                plain
                >查询</el-button
              >
              <el-button type="warning" icon="el-icon-plus" @click="addOldman" plain>添加</el-button>
              <el-button type="info" @click="toLead" icon="el-icon-upload" plain>导入</el-button>
              <el-button type="info" @click="downAllOldman" icon="el-icon-document" plain>导出</el-button>
            </el-form-item>
          </el-form>
          <el-table
            style="width: 100%"
            :data="tableData"
            v-loading="tableLoading"
            :header-cell-style="{
              'text-align': 'center',
              'font-size': '16px',
              'font-weight': '600',
               color: '#2d2d2d',
              'background-color': '#d4f5fa',
            }"
            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
            :row-style="tableRowStyle"
          >
            <el-table-column
              prop="oldName"
              label="老人姓名"
              min-width="90"
            ></el-table-column>
            <el-table-column
              prop="oldAge"
              label="年龄"
              min-width="50"
            ></el-table-column>
            <el-table-column
              prop="sex"
              label="性别"
              min-width="50"
            >
              <template slot-scope="scope">
                <p>{{scope.row.sex == 0?"男":"女"}}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="oldIdCard"
              label="身份证号"
              min-width="170"
            ></el-table-column>
            <el-table-column
              prop="oldAddress"
              label="家庭住址"
              show-overflow-tooltip

              min-width="150"
            ></el-table-column>
            <el-table-column
              prop="oldPhone"
              label="长者电话"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="状态"
            ><template slot-scope="scope">
              <p>{{scope.row.serviceType == 1?"在院":"离院"}}</p>
            </template>
            </el-table-column>
            <el-table-column
              prop="interest"
              label="老人类别"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="levelCareName"
              label="自理类型"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="registryTime"
              label="入院日期"
              :formatter="formatTime"
              min-width="120"
            ></el-table-column>
            <el-table-column label="操作" min-width="80">
              <template slot-scope="scope">
                <a @click="handleEdit(scope.$index, scope.row)" class="curcor">
                  <img class="handedness" src="@/assets/beadhouse/xiugai_icon_1.png" />
                </a>
                <a @click="handleDetail(scope.$index, scope.row)" class="curcor" style="margin-left:20px">
                  <img
                    class="handedness"
                    src="@/assets/beadhouse/chakan_icon.png"
                  />
                </a>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          >
          </el-pagination>
      </el-row>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  import { baseURL } from "@/utils/request.js";
  export default {
    name: "ResidentManager",
    data() {
      return {
        formInline: {
          oldName: "",
          oldPhone: "",
          sex: "",
          levelCareName:"",
          serviceType:""
        },
        tableData: [], //表格数据
        tableLoading: false, //表格加载的loading
        /* 分页的 */
        currentPage: 1, //初始页
        toLeadVisisble:false,
        pageNo: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber: 0, //数据的总数,
        fieldsVisisble: false,
        oldNameOptions: [], // 老人姓名集合
      };
    },
    methods: {
      //修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      formatTime: function (row) {
        if (row.registryTime != null) {
          return row.registryTime;
        } else {
          var date = new Date(row.createTime)
          var Y = date.getFullYear()
          var M = date.getMonth() + 1
          var D = date.getDate()
          return Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
        }
      },
      /*
        点击查询
      */
      search() {
        this.queryOldman(
            this.formInline.oldName,
            this.formInline.oldPhone,
            this.formInline.sex,
            this.formInline.serviceType,
            this.formInline.levelCareName,
            (this.pageNo = 1),
            (this.pageSize = 10)
          );
      },
      /*
        键盘事件 按下键盘回车 查询
      */
      enterSearchMember(e) {
        // console.log("回车搜索", keyCode, e);
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13 && this.formInline.oldName != null) {
          this.search();
        }
      },
      handleDetail(index, row) {
        sessionStorage.setItem("oldmanId", row.oldmanId);
        bus.$emit("homePage", {
          type: "jump",
          path: "/flyOldmanDetail",
          title: "老人档案",
        });
      },
      /*
        查询老人分页列表
      */
      queryOldman() {
        // console.log(this.formInline.status == "0");
        let params = {};
        if (this.formInline.oldName != "" || null || undefined) {
          params.oldName = this.formInline.oldName;
        }
        if (this.formInline.sex != "" || null || undefined) {
          params.sex = this.formInline.sex;
        }
        if (this.formInline.serviceType != "" || null || undefined) {
          params.serviceType = Number(this.formInline.serviceType);
        }
        if (this.formInline.levelCareName != "" || null || undefined) {
          params.levelCareName = this.formInline.levelCareName;
        }
        params.pageNo = String(this.pageNo);
        params.pageSize = String(this.pageSize);
        this.tableData = [];
        this.tableLoading = true;
        this.$postJson("omc/Oldman/showOldManSupAll", params).then((res) => {
          if (res.code == 200) {
            if (res.result.list != null) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.tableData = res.result.list;
            } else {
              this.tableData = [];
              this.pageSize = 10;
              this.currentPage = 1;
              this.totalDataNumber = 0;
            }
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
          setTimeout(() => {
            this.tableLoading = false;
          }, 500);
        });
      },
      handleSizeChange(val) {
        this.PageSize = val;
        this.queryOldman(); //刷新套餐列表的数据
      },
      handleCurrentChange(val) {
        this.pageNo = val;
        this.queryOldman(); //刷新套餐列表的数据
      },
      //导出
      downLoad() {
        window.location.href =
          baseURL +
          `omc/api/downOldManInformation?groupId=${window.sessionStorage.getItem("groupId")}`;
      },
      handleEdit(index,row){
        sessionStorage.setItem("editOldmanId", row.oldmanId);
        bus.$emit("homePage", {
          type: "jump",
          path: "/flyOldmanEdit",
          title: "编辑老人信息"
        });
      },
      addOldman(){
        bus.$emit("homePage", {
          type: "jump",
          path: "/flyOldmanAdd",
          title: "新增老人",
        });
      },
    },
    mounted() {
      this.queryOldman();
    },
  };
  </script>
  <style lang="scss" scoped>
  .fenye {
    padding: 30px 0;
    margin: 0px auto;
    background: #fff;
  }
  </style>
  